<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,9.5C13.44,9.5,12.94,9.73,12.58,10.09C12.58,10.09,8.99,8,8.99,8C8.99,8,12.58,5.91,12.58,5.91C12.94,6.27,13.44,6.5,14,6.5C15.1,6.5,16,5.6,16,4.5C16,3.4,15.1,2.5,14,2.5C12.9,2.5,12,3.4,12,4.5C12,4.69,12.03,4.87,12.08,5.04C12.08,5.04,8.5,7.13,8.5,7.13C8.5,7.13,8.5,3.93,8.5,3.93C9.36,3.71,10,2.93,10,2C10,0.9,9.1,0,8,0C6.9,0,6,0.9,6,2C6,2.93,6.64,3.71,7.5,3.93C7.5,3.93,7.5,7.13,7.5,7.13C7.5,7.13,3.92,5.04,3.92,5.04C3.97,4.87,4,4.69,4,4.5C4,3.4,3.1,2.5,2,2.5C0.9,2.5,0,3.4,0,4.5C0,5.6,0.9,6.5,2,6.5C2.56,6.5,3.06,6.27,3.42,5.91C3.42,5.91,7.01,8,7.01,8C7.01,8,3.42,10.09,3.42,10.09C3.06,9.73,2.56,9.5,2,9.5C0.9,9.5,0,10.4,0,11.5C0,12.6,0.9,13.5,2,13.5C3.1,13.5,4,12.6,4,11.5C4,11.31,3.97,11.13,3.92,10.96C3.92,10.96,7.5,8.87,7.5,8.87C7.5,8.87,7.5,12.07,7.5,12.07C6.64,12.29,6,13.07,6,14C6,15.1,6.9,16,8,16C9.1,16,10,15.1,10,14C10,13.07,9.36,12.29,8.5,12.07C8.5,12.07,8.5,8.87,8.5,8.87C8.5,8.87,12.08,10.96,12.08,10.96C12.03,11.13,12,11.31,12,11.5C12,12.6,12.9,13.5,14,13.5C15.1,13.5,16,12.6,16,11.5C16,10.4,15.1,9.5,14,9.5C14,9.5,14,9.5,14,9.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutAuto',
} as DefineComponent
</script>
